/** Compact display only. Keep underlying satoshi amounts unchanged. */
export function formatActivityBtc(sats: number): string {
 if (!Number.isFinite(sats) || sats <= 0) return '0.0000'
 if (sats < 10000) return '<0.0001'
 // Truncate at four decimals, rather than rounding a sale amount upward.
 return (Math.floor(sats / 10000) / 10000).toFixed(4)
}
